var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectCrossIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.054 17.963C14.2956 17.963 17.734 14.5246 17.734 10.283C17.734 6.04148 14.2956 2.60303 10.054 2.60303C5.81248 2.60303 2.37402 6.04148 2.37402 10.283C2.37402 14.5246 5.81248 17.963 10.054 17.963ZM8.81285 7.68421C8.43794 7.3093 7.8301 7.3093 7.4552 7.68421C7.0803 8.05911 7.0803 8.66695 7.4552 9.04185L8.69638 10.283L7.4552 11.5242C7.0803 11.8991 7.0803 12.5069 7.4552 12.8819C7.8301 13.2568 8.43794 13.2568 8.81285 12.8819L10.054 11.6407L11.2952 12.8819C11.6701 13.2568 12.2779 13.2568 12.6528 12.8819C13.0278 12.5069 13.0278 11.8991 12.6528 11.5242L11.4117 10.283L12.6528 9.04185C13.0278 8.66695 13.0278 8.05911 12.6528 7.68421C12.2779 7.3093 11.6701 7.3093 11.2952 7.68421L10.054 8.92538L8.81285 7.68421Z",
    fill: "#F31260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectCrossIcon);
export default __webpack_public_path__ + "static/media/reject-cross-icon.d11488568865b7cde817884b1ca4de1a.svg";
export { ForwardRef as ReactComponent };